import { render, staticRenderFns } from "./BdRedirect.vue?vue&type=template&id=13038299&"
import script from "./BdRedirect.vue?vue&type=script&lang=js&"
export * from "./BdRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports